import Vue from "vue";

export default {
  data: () => ({
    valid: false,
    sended: false,
    result: null,
    radioGroup: null,
    type: null,
    loading: false,
    radios: [
      {
        title: "Membership info inquiry (only for non-member companies)",
        value: 0,
      },
      {
        title: "Other inquiry",
        value: 1,
      },
    ],
    firstname: "",
    lastname: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => v.length <= 20 || "Name must be less than 20 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    subject: "",
    subjectRules: [
      (v) => !!v || "Subject is required",
      (v) => v.length <= 50 || "Subject must be less than 50 characters",
    ],
    message: "",
    messageRules: [
      (v) => !!v || "Message is required",
      (v) => v.length <= 1000 || "Message must be less than 1000 characters",
    ],
    agree: false,
  }),

  methods: {
    radioSelected() {
      parent.postMessage("externalFormEvent", "*");
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        let data = {
          type: this.radios[this.radioGroup].title,
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          subject: this.subject,
          message: this.message,
          agree: this.agree,
        };

        this.type = data.type;

        this.$refs.form.resetValidation();

        this.loading = true;

        Vue.axios
          .post(
            "https://www.virtualexhibition.o-ran.org/api/Form/SendGlobalForm",
            data
          )
          .then((response) => {
            this.loading = false;

            if (response.data == "success") {
              this.radioGroup = 0;
              this.firstname = "";
              this.lastname = "";
              this.email = "";
              this.subject = "";
              this.message = "";
              this.agree = false;

              parent.postMessage("externalFormEventSuccess", "*");
              this.result = true;
              this.sended = true;
            } else {
              // error
              parent.postMessage("externalFormEventError", "*");
              this.result = false;
            }
          });
      }
    },
  },
};
